module.exports = "<div class=\"cabecalho col-md-12 col-sm-12 col-xs-12\">\n  <div class=\"container center\">\n    <img src=\"assets/images/marca_branca.png\" class=\"logo\" alt=\"Logo\" title=\"Univali\">\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/cabecalho/cabecalho.component.html
// module id = ./src/app/cabecalho/cabecalho.component.html
// module chunks = main